class BannerSliderComponent extends HTMLElement {
  constructor() {
    super();
  } 

  connectedCallback() {
    this.initSlider();
    
    // Support Shopify Theme Editor (Design Mode) events
    this.onSectionLoad = (e) => {
      if (e.target.contains(this)) {
        this.initSlider();
      }
    };
    this.onBlockSelect = (e) => {
      if (e.target.contains(this) && this.swiperInstance) {
        const slideIndex = Array.from(this.querySelectorAll('.swiper-slide')).indexOf(e.target);
        if (slideIndex !== -1) {
          this.swiperInstance.slideToLoop(slideIndex);
        }
      }
    };

    document.addEventListener('shopify:section:load', this.onSectionLoad);
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  initSlider() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }

    const slidesDesktop = parseFloat(swiperEl.dataset.slideDesktop) || 1; 
    const slidesTablet = parseFloat(swiperEl.dataset.slideTablet) || 1;
    const slidesMobile = parseFloat(swiperEl.dataset.slideMobile) || 1;

    const isMobile = window.innerWidth < 750;

    this.swiperInstance = new Swiper(swiperEl, {
      slidesPerView: slidesMobile,
      spaceBetween: 5,
      grabCursor: true,
      loop: true, 
      speed: 800,
      autoplay: isMobile ? false : {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: this.querySelector('.block__banner-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector('.block__banner-next'),
        prevEl: this.querySelector('.block__banner-prev'),
      },
      breakpoints: {
        750: {
          slidesPerView: slidesTablet,
          spaceBetween: 6
        },
        990: {
          slidesPerView: slidesDesktop,
          spaceBetween: 8
        }
      }
    });
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }
    document.removeEventListener('shopify:section:load', this.onSectionLoad);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }
}

customElements.define('banner-slider-component', BannerSliderComponent);
